export const SPECIFIC_HOSTED_VENUES = [
  'artspecials.de',
  'test1.activeimage.store',
  'test2.activeimage.store',
  'test1.activeimage.site',
  'test2.activeimage.site',
  'activeimage.site',
];
